// extracted by mini-css-extract-plugin
export default {"tagsInput":"TestInput_tsx_tagsInput__YfizN"};